<template>
  <div class="marketplace-sidebar position-fixed overflow-auto d-block top-0 bottom-0 start-0 px-0 border-end border-300"
       :class="{'customized-affiliate': !!affiliateCustomizations}"
       :style="appStyleProps">
    <div class="d-flex flex-column h-100">
      <MarketplaceLogo />
      <div class="sidebar-nav flex-grow-1 px-5"
        :class="{'customized-affiliate': !!affiliateCustomizations}">
        <div class="pt-lg-6" v-if="showAppConfigNav">
          <AppConfigNav />
        </div>
        <SidebarNavigation v-else class="px-4" />
      </div>
      <MarketplaceWidgets view="desktop" v-if="showWidgets && !affiliateCustomizations"/>
      <AffiliateCustomSidebarWidgets view="desktop" v-if="!!affiliateCustomizations && (poweredByLendioEnabled || contactInfoEnabled)" />
    </div>
  </div>
</template>

<script>
  import { mapState } from 'pinia';
  import { useAffiliateCustomizationStore } from '~/store/affiliate-customization'
  import { useBorrowerStore } from '~/store/borrower'
  import AffiliateCustomSidebarWidgets from '~/components/sba/AffiliateCustomSidebarWidgets.vue'
  import env from '~/libs/env'
  import MarketplaceLogo from '~/components/marketplace/MarketplaceLogo.vue'
  import MarketplaceWidgets from '~/components/marketplace/MarketplaceWidgets.vue'
  import SidebarNavigation from '~/components/SidebarNavigation.vue'
  import AppConfigNav from '~/components/app-config/AppConfigNav.vue'

  export default {
    name: 'MarketplaceSidebar',
    components: {
      AffiliateCustomSidebarWidgets,
      MarketplaceWidgets,
      MarketplaceLogo,
      SidebarNavigation,
      AppConfigNav
    },
    props: ['showAppConfigNav'],
    data: () => ({
      showWidgets: !env('tenantName'),
    }),
    computed: {
      ...mapState(useAffiliateCustomizationStore, [
        'appStyleProps',
        'affiliateCustomizations',
        'poweredByLendioEnabled',
        'contactInfoEnabled'
      ]),
      ...mapState(useBorrowerStore, ['borrower'])
    }
  }
</script>

<style lang="scss" scoped>
$app-aside-background-color: var(--app-aside-background-color);
.sidebar-nav {
  border-top: 1px solid $border-200;
  &.customized-affiliate {
    /* Placeholder for JIRA ticket OFF-835.  */
    border-top: 0px solid $app-aside-background-color;
  }
}

.marketplace-sidebar {
  z-index: $zindex-fixed;
  width: 320px;
  background: $neutral-200;

  &.customized-affiliate {
    background: $app-aside-background-color;
  }
}

</style>
